module.exports = __webpack_public_path__ + "img/driver-lounge.6e3e7cd0.svg";